import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { of, tap } from "rxjs";
import { ApiClientService } from "~app/common/services/api-client.service";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { DokumentUrlDTO } from "~app/pages/dokument/model/DokumentUrlDTO";
import { GetArbetsorderDokumentUrlQuery } from "./GetArbetsorderDokumentUrlQuery";

export const dokumentArbetsorderBeteckningResolver: ResolveFn<DokumentUrlDTO> = (route, _state) => {
    const apiClientService = inject(ApiClientService);
    const { beteckning, typ } = route.params;

    if(!typ || !beteckning) {
        return of(null);
    }

    const query: GetArbetsorderDokumentUrlQuery = {
        arbetsorderBeteckning: beteckning,
        typ: typ
    };

    return apiClientService.get<DokumentUrlDTO>("arbetsorder/dokumenturl", false, query).pipe(
        tap<DokumentUrlDTO>(dokumentDto => {
            if(ObjectUtils.hasValue(dokumentDto?.url)) {
                window.location.href = dokumentDto.url;
            }
            return dokumentDto;
        })
    );
};
